export default __webpack_public_path__ + "static/static-asset-threeBolts-eeae19895f423cb9908dcfdec6a31a0d.svg";